import { render, staticRenderFns } from "./radio_group.vue?vue&type=template&id=6a80067f&scoped=true"
import script from "./radio_group.vue?vue&type=script&lang=js"
export * from "./radio_group.vue?vue&type=script&lang=js"
import style0 from "./radio_group.vue?vue&type=style&index=0&id=6a80067f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a80067f",
  null
  
)

export default component.exports